import React from 'react'

export default function LegacyNutshell() {
  return (
    <section className="legacy-ensure text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="common-heading">
              <h2><span> Our Legacy </span> ENSURING 'CARE' IN HEALTHCARE </h2>
            </div>
            <div className="legacy-details">
              On May 8, 1974, Anand Diagnostic Laboratory began its journey in Shivajinagar, Bangalore, under Dr. A V Ramaprasad's visionary leadership. Rooted in principles of honesty and integrity, the lab became a beacon for quality diagnostics, always putting patients first. Currently, Anand Diagnostics Laboratory is known as Neuberg Anand Reference Laboratory, carrying forward its legacy of excellence and patient-centered care.e
            </div>
            <div className="nutshell">
              <div className="common-heading">
                <h2><span>About Anand Lab </span> In a nutshell </h2>
              </div>
              <div className="nutshell-count">
                <ul>
                  <li>
                    <h4 className="home-counter-text"> <span className="counter">50</span> <span className="clr-pnk">+</span> </h4>
                    <h5>Years of Diagnostic Excellence</h5>
                  </li>
                  <li>
                    <h4 className="home-counter-text"> <span className="counter">200</span> <span className="clr-pnk">+</span> </h4>
                    <h5>Touch points across Karnataka</h5>
                  </li>
                  <li>
                    <h4 className="home-counter-text"> <span className="counter">800</span> <span className="clr-pnk">+</span> </h4>
                    <h5>Employees </h5>
                  </li>
                  <li>
                    <h4 className="home-counter-text"> <span className="counter">6000</span> <span className="clr-pnk">+</span> </h4>
                    <h5>Varieties of Diagnostic Investigations</h5>
                  </li>
                  <li>
                    <h4 className="home-counter-text"> <span className="counter">1.2</span>M <span className="clr-pnk">+</span> </h4>
                    <h5>Blood Sample collections per year</h5>
                  </li>
                  {/* <li>
                    <h4 className="home-counter-text"> <span className="counter">20</span>M <span className="clr-pnk">+</span> </h4>
                    <h5>Blood tests across Neuberg Labs per year</h5>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
